import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommandsService } from 'src/app/core/services/command.service';
import {
  CommandinfoType,
  CommandSelect,
  CommandsResponse,
  CommandStatus,
  CommandStatusEnum,
  CommandToSend,
  Timeout,
  SelectAccessory
} from '../../../core/models/commands.model';

import { UntypedFormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { saveAs } from 'file-saver';
import { ClipboardService } from 'ngx-clipboard';
import { Enviroment } from 'src/app/core/models/environment';
import { AuthService } from 'src/app/core/services/auth.service';
import { ToastService } from 'src/app/shared/widget/notification/toast-service';
@Component({
  selector: 'app-commands',
  templateUrl: './commands.component.html',
  styleUrls: ['./commands.component.scss'],
  providers: [DatePipe, UntypedFormBuilder],
})

//TODO: Implementar Cancelar comandos
//TODO: Melhorar a visualização da tabela
//TODO: Verificar como chamar o ambiente correto para carregar os comandos, prod, homolog ou dev
export class CommandsComponent implements OnInit {
  user: any;
  isUserAdmin = false;
  isUserAll = false;
  constructor(
    private modalService: NgbModal,
    public datePipe: DatePipe,
    public commandsService: CommandsService,
    public formBuilder: UntypedFormBuilder,
    public toastService: ToastService,
    private _clipboardService: ClipboardService,
    private authService: AuthService,
    private sanitizer: DomSanitizer
  ) {
    this.user = this.authService.currentUserValue;
    this.isUserAdmin = this.authService.isUserAdmin;
    this.isUserAll = this.authService.isUserAll;
  }

  public circularProgressiveWait: boolean = false;
  public seriais: string = '';
  public mensagemErro: string = '';
  dateStart: string = '';
  dateEnd: string = '';
  public commandResponse: CommandsResponse[] = [];
  public commandInfoType: CommandinfoType[] = [];
  public commandoStatus: any = CommandStatus;
  public commandStatusEnum = CommandStatusEnum;
  public commandStatusString: string[] = [];
  public commandName: any = {};
  public commandCustom: string = '';
  public enviroment = Enviroment;
  public enviromentSearch = '';
  public commandToSendItem: CommandToSend = {
    tipo: 0,
    serial: '',
    sistema: 'logan',
  };

  public timeOutKeys: any = Object.values(Timeout).slice(
    0,
    Object.keys(Timeout).length / 2
  );

  public timeOutValues: any = Object.values(Timeout).slice(
    Object.keys(Timeout).length / 2,
    Object.keys(Timeout).length
  );

  public selectAccessory : SelectAccessory[] = [];
  //public commandSelect!: CommandinfoType;
  public commandSelect: CommandSelect = {
    id: -1,
    comandoId: -1,
    nome: 'Selecione um comando',
    dispositivoModeloId: -1,
    dispositivoModelo: '',
    observacaoHTML: '',
    exemplo: '',
    valor: false,
    canalEnvio: '',
    param: '',
    seriais: '',
    timeout: '0',
    ambiente: this.enviroment.prod.toString(),
    paramAux: '',
    idAccessory : -1
  };

  ngOnInit(): void {
    this.dateStart = this.datePipe.transform(
      new Date(),
      'yyyy-MM-ddT00:00:00'
    )!;
    this.dateEnd = this.datePipe.transform(new Date(), 'yyyy-MM-ddT23:59:59')!;

    this.commandsService.getCommandsInfoType().subscribe(
      (response: any) => {
        if (response != null) {
          this.commandName = {};
          response.forEach((item: CommandinfoType) => {
            let index = this.commandInfoType.findIndex((item2) => {
              return item2.comandoId == item.comandoId;
            });

            if (index == -1) {
              this.commandName[item.comandoId.toString()] = item.nome;
              if (item.observacaoHTML != null && item.observacaoHTML != '') {
                item.observacaoHTML = `<p>${
                  item.dispositivoModelo != undefined &&
                  item.dispositivoModelo != null
                    ? item.dispositivoModelo + ' → '
                    : ''
                }${item.observacaoHTML}</p>`;
              }

              this.commandInfoType.push(item);
            } else {
              if (item.observacaoHTML != null && item.observacaoHTML != '') {
                let aux =
                  this.commandInfoType[index].observacaoHTML.split(' → ');
                if (
                  aux[aux.length - 1].substring(
                    0,
                    aux[aux.length - 1].length - 4
                  ) == item.observacaoHTML
                ) {
                  if (
                    this.commandInfoType[index].observacaoHTML.substring(
                      0,
                      3
                    ) == '<p>'
                  ) {
                    this.commandInfoType[index].observacaoHTML =
                      this.commandInfoType[index].observacaoHTML.substring(
                        3,
                        this.commandInfoType[index].observacaoHTML.length
                      );
                  }
                  this.commandInfoType[
                    index
                  ].observacaoHTML = `<p>${item.dispositivoModelo}, ${this.commandInfoType[index].observacaoHTML}`;
                } else {
                  this.commandInfoType[index].observacaoHTML = `${
                    this.commandInfoType[index].observacaoHTML
                  }<p>${
                    item.dispositivoModelo != undefined &&
                    item.dispositivoModelo != null
                      ? item.dispositivoModelo + ' → '
                      : ''
                  }${item.observacaoHTML}</p>`;
                }
              }
              if(item.isAccessory == true && item.dispositivoModelo != null) {
                let accessory = new SelectAccessory(item);
                this.selectAccessory.push(accessory)                
              }
            }
          });
          this.selectAccessory.sort((a, b) => a.accessoryModeloId - b.accessoryModeloId);
        }
      },

      (error: HttpErrorResponse) => {
        this.toastService.show('Erro ao pesquisar - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
      }
    );
  }

  returnTimeOutName(timeout: number) {
    let index = this.timeOutValues.findIndex((item: any) => {
      return item == timeout / 1000;
    });

    if (index > -1) {
      return this.timeOutKeys[index];
    } else {
      return `\n${(timeout / 1000).toString()}s / ${(timeout / 1000 / 86400)
        .toPrecision()
        .toString()} dias`;
    }
  }
  copyCommand(text: string) {
    this._clipboardService.copy(text);
  }
  get accessoryExists(): boolean {
    return this.selectAccessory?.some(item => item.tipo === this.commandSelect?.comandoId);
  }
  filterCommand(command: any) {
    this.commandSelect.idAccessory = -1;
    var commandAux: string = '';
    try {
      var commandAux: string = command['$ngOptionLabel'].trim();
    } catch (error) {}
    var commandoSelectAux = this.commandInfoType.filter((item) => {
      return item.nome == commandAux;
    });

    this.commandSelect.comandoId = -1;
    this.commandSelect.nome = commandAux;
    this.commandSelect.dispositivoModeloId;
    this.commandSelect.observacaoHTML = '';
    this.commandSelect.exemplo = '';
    this.commandSelect.valor = false;
    this.commandSelect.param = '';
    if (
      commandoSelectAux.length > 0 &&
      commandoSelectAux[0].observacaoHTML != undefined &&
      commandoSelectAux[0].observacaoHTML != null &&
      commandoSelectAux[0].observacaoHTML != ''
    ) {
      this.commandSelect.observacaoHTML =
        this.sanitizer.bypassSecurityTrustHtml(
          commandoSelectAux[0].observacaoHTML
        ) as string;
    }
    try {
      this.commandSelect.comandoId = commandoSelectAux[0].comandoId;
      this.commandSelect.valor = commandoSelectAux[0].valor ?? false;

      {
        if (
          commandoSelectAux[0].exemplo != undefined &&
          commandoSelectAux[0].exemplo != null &&
          commandoSelectAux[0].exemplo != ''
        )
          this.commandSelect.exemplo = commandoSelectAux[0].exemplo;
      }
    } catch (error) {}
  }

  openModalCommandCustom(centerDataModal: any) {
    this.modalService.open(centerDataModal, {
      centered: true,
      windowClass: 'modal-holder',
    });
  }
  openModalCommandDefault(centerDataModal: any) {
    this.modalService.open(centerDataModal, {
      centered: true,
      windowClass: 'modal-holder',
    });
  }

  verifyAllCommandSend(
    responseCommand: String[],
    seriaisSend: String[],
    forceSendGateway: boolean
  ) {
    if (responseCommand.includes("Comando adicionado com sucesso") || responseCommand.length == 0) {
      this.toastService.show('Comandos enviados', {
        classname: 'bg-success text-center text-white',
        delay: 2500,
      });
    }
    else {
      this.toastService.show(
        (forceSendGateway
          ? `${responseCommand.length} - `
          : `Erro ao enviar comandos: ${responseCommand.length} - `) +
          responseCommand.join(';'),
        {
          classname: 'bg-warning text-center text-white',
          delay: 10000,
        }
      );
    }
  }
  sendCommandDefault() {
    let elementForceSendGateway: any =
      document.getElementById('forceSendGateway');
    let elementIsACII: any = document.getElementById('isASCII');
    let forceSendGateway = false;
    let isASCII = false;
    if (elementForceSendGateway) {
      forceSendGateway = elementForceSendGateway.checked;
    }
    if (elementIsACII) {
      isASCII = elementIsACII.checked;
    }
    this.circularProgressiveWait = true;
    this.commandToSendItem.param =
      this.commandSelect.param == ''
        ? undefined
        : this.commandSelect.param.trim();

    this.commandToSendItem.tipo = this.commandSelect.comandoId;
    this.commandToSendItem.timeout =
      this.commandSelect.timeout == -1
        ? undefined
        : this.timeOutValues[this.commandSelect.timeout];
    var comandoPersonalizado =
      this.commandSelect.nome.toUpperCase() == 'PERSONALIZADO' ? true : false;
    var seriaisList = this.commandSelect.seriais.split(';');
    this.commandToSendItem.serial = this.commandSelect.seriais;
    if(this.commandSelect.idAccessory != -1 && this.commandSelect.idAccessory != null) {
      this.commandToSendItem.idAccessory = this.commandSelect.idAccessory;
    }  
    this.commandsService
      .postSendCommand(
        this.commandToSendItem,
        this.user.userId,
        forceSendGateway,
        isASCII
      )
      .subscribe(
        (response: String[]) => {
          this.verifyAllCommandSend(response, seriaisList, forceSendGateway);
          this.searchCommands(seriaisList);
          this.seriais = seriaisList.join(';');
          this.commandSelect.idAccessory = -1;
        },
        (error) => {
          this.toastService.show(
            (forceSendGateway ? '' : 'Erro ao enviar comandos - ') + error[0],
            {
              classname: 'bg-warning text-center text-white',
              delay: 10000,
            }
          );
          this.searchCommands(seriaisList);
          this.seriais = seriaisList.join(';');
        }
      );
  }
  returnEnvironment(enviroment: string) {
    return Object.entries(this.enviroment).filter((item: any) => {
      return item[0] == enviroment;
    })[0][1];
  }
  searchCommands(seriaisAux: string[]) {
    if (!seriaisAux[0]){
      this.mensagemErro = "O campo Seriais não pode ser vazio!";
    }
    else {
    this.commandResponse = [];
    var seriais: any = [];
    var seriaisSplit = [];
    seriaisSplit = seriaisAux;
    seriaisSplit.forEach((seriaisItem) => {
      seriais.push({ serial: seriaisItem.trim() });
    });
    if (seriais.length > 0) {
      this.mensagemErro = '';
      this.circularProgressiveWait = true;
      this.commandsService
        .searchCommandsResponse(
          seriais,
          Date.parse(this.dateStart),
          Date.parse(this.dateEnd)
        )
        .subscribe((response: any) => {
          if (response != null && this.commandResponse.length == 0) {
            var comandoResponse: CommandsResponse[] = response;
            if (comandoResponse != null && comandoResponse.length > 0) {
              comandoResponse.forEach((item) => {
                item.dataEnvio =
                  item.dataEnvio != null && Number(item.dataEnvio) > 0
                    ? new Date(item.dataEnvio).toLocaleDateString() +
                      ' ' +
                      new Date(item.dataEnvio).toLocaleTimeString()
                    : '';
                item.dataRequisicao =
                  item.dataRequisicao != null && Number(item.dataRequisicao) > 0
                    ? new Date(item.dataRequisicao).toLocaleDateString() +
                      ' ' +
                      new Date(item.dataRequisicao).toLocaleTimeString()
                    : '';
                item.dataResposta =
                  item.dataResposta != null && Number(item.dataResposta) > 0
                    ? new Date(item.dataResposta).toLocaleDateString() +
                      ' ' +
                      new Date(item.dataResposta).toLocaleTimeString()
                    : '';
                var index = this.commandResponse.findIndex(
                  (itemResponse: CommandsResponse) => {
                    return itemResponse.id == item.id;
                  }
                );
                if (index > -1) {
                  this.commandResponse[index].comando =
                    this.commandStatusEnum[
                      this.commandResponse[index].statusId
                    ] +
                    ' -> ' +
                    this.commandResponse[index].comando +
                    '\n' +
                    this.commandStatusEnum[item.statusId] +
                    ' -> ' +
                    item.comando;
                } else {
                  this.commandResponse.push(item);
                }
              });
            } else {
              this.circularProgressiveWait = false;
            }
            this.circularProgressiveWait = false;
          }
        },
      (erro : any) => {
          console.log(erro)
      })
        ;
      }
    }
  }

  cancelCommand(solicitacaoComandoId: string, system: string) {
    this.commandsService
      .getCancelCommands(solicitacaoComandoId, system)
      .subscribe(
        (response: any) => {
          if (response != null) {
            this.toastService.show('Comando cancelado: ', {
              classname: 'bg-success text-center text-white',
              delay: 10000,
            });
          }
        },
        (error: HttpErrorResponse) => {
          this.toastService.show('Erro ao cancelar comando: ' + error, {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          });
        }
      );
  }
  getFields(event: any): any {
    let options: string[] = [];
    Object.entries(event).forEach((item: any) => {
      let key: string[] = [];
      item.forEach((itemAux: any) => {
        switch (typeof itemAux) {
          case 'string':
            if (itemAux == item[0]) key.push(itemAux);
            if (itemAux == item[0] && typeof item[1] != 'object')
              options.push(itemAux);
            break;
          case 'object':
            if (itemAux == null) {
              options.push(item[0]);
              break;
            }
            Object.entries(itemAux).forEach((subItem: any) => {
              subItem.forEach((subItemAux: any) => {
                console.log(subItemAux);
                console.log(typeof subItemAux);
                switch (typeof subItemAux) {
                  case 'string':
                    if (
                      subItemAux == subItem[0] &&
                      typeof subItem[1] != 'object'
                    ) {
                      options.push(item[0] + '.' + subItemAux);
                    }
                    break;
                  //@ts-ignore
                  case 'object':
                    if (subItemAux == null) {
                      options.push(item[0] + '.' + subItem[0]);
                      break;
                    }
                    Object.entries(subItemAux).forEach((subsubItem: any) => {
                      subsubItem.forEach((subsubItemAux: any) => {
                        switch (typeof subsubItemAux) {
                          case 'string':
                            if (
                              subsubItemAux == subsubItem[0] &&
                              typeof subsubItem[1] != 'object'
                            ) {
                              options.push(
                                item[0] + '.' + subItem[0] + '.' + subsubItemAux
                              );
                            }
                            break;
                          default:
                            break;
                        }
                      });
                    });
                  default:
                    break;
                }
              });
            });
            break;
          default:
            break;
        }
      });
    });
    options.forEach((item) => {
      if (!options.includes(item)) {
        options.push(item);
      }
    });
    return options;
  }

  //Export Excel
  exportExcel() {
    try {
      let fieldAux: any[] = [];
      this.commandResponse.forEach((command) => {
        fieldAux = this.getFields(command);
      });
      let headers = [
        'serial',
        'dataEnvio',
        'dataRequisicao',
        'dataResposta',
        'comandoTipoId',
        'statusId',
      ];
      fieldAux.forEach((item: any) => {
        let notExist =
          headers.findIndex((header: any) => {
            return header == item;
          }) > -1
            ? false
            : true;
        if (notExist) {
          headers.push(item);
        }
      });
      let json: Object[] = [];
      this.commandResponse.forEach((command: any) => {
        let jsonAux: string[] = [];

        headers.forEach((header: any) => {
          let field = header.split('.');
          let commandAux = command;
          let commandValue = '"' + header + '":""';
          field.forEach((item: any) => {
            let value = '';
            if (item in commandAux) {
              if (item == field[field.length - 1]) {
                switch (header) {
                  case 'statusId':
                    commandValue =
                      '"status":"' +
                      this.commandStatusEnum[
                        Number(commandAux[item])
                      ].toString() +
                      '"';
                    break;
                  case 'comandoTipoId':
                    commandValue =
                      '"comandoTipo":"' +
                      this.commandName[Number(commandAux[item])].toString() +
                      '"';
                    break;
                  case 'timeout':
                    commandValue =
                      '"' +
                      header +
                      '":"' +
                      this.returnTimeOutName(commandAux[item]).toString() +
                      '"';
                    break;
                  case 'parametros':
                    if (commandAux[item] != null) {
                      value = commandAux[item].toString();
                      try {
                        if (
                          atob(value).toLocaleLowerCase().startsWith('55aa55aa')
                        ) {
                          value = atob(value);
                        }
                      } catch (err) {}
                    }
                    commandValue = '"' + header + '":"' + value + '"';
                    break;
                  default:
                    if (commandAux[item] != null) {
                      value = commandAux[item].toString();
                    }

                    commandValue = '"' + header + '":"' + value + '"';
                    break;
                }
              }
              // commandAux = commandAux[item];
            }
          });
          jsonAux.push(commandValue);
        });

        let jsonReplaced = jsonAux.join(',');

        jsonReplaced = jsonReplaced.replace(/\n|\&|\r|\t|\b|\f/g, (match) => {
          switch (match) {
            case '\n':
              return '\\n';
            case '&':
              return '&';
            case '\r':
              return '\\r';
            case '\t':
              return '\\t';
            case '\b':
              return '\\b';
            case '\f':
              return '\\f';
            default:
              return match;
          }
        });
        jsonReplaced = JSON.parse('{' + jsonReplaced + '}');
        json.push(jsonReplaced);
      });

      import('xlsx').then((xlsx) => {
        const worksheet = xlsx.utils.json_to_sheet(json);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, {
          bookType: 'xlsx',
          type: 'array',
        });
        this.saveAsExcelFile(excelBuffer, `commands`);
      });
    } catch (error: any) {
      this.toastService.show('Erro ao exportar - ' + error, {
        classname: 'bg-danger text-center text-white',
        delay: 10000,
      });
    }
  }
  currentDate = new Date();
  month: number = this.currentDate.getMonth() + 1;
  day: number = this.currentDate.getDate();
  year: number = this.currentDate.getFullYear();
  hour: number = this.currentDate.getHours();
  minutes: number = this.currentDate.getMinutes();

  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName +
          '_export_' +
          this.year +
          this.month +
          this.day +
          '_' +
          this.hour +
          this.minutes +
          EXCEL_EXTENSION
      );
    });
  }
}
